var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('SideMenu'),_c('div',{staticClass:"inner"},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
var route = ref.route;
return [_c('transition',{attrs:{"name":"fade"}},[_c(Component,{key:route.path,tag:"component"})],1)]}}])})],1),(_vm.$store.state.showLightbox)?_c('image-lightbox'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }